import { FC, SVGProps } from 'react';

import FileDownload16 from '@/assets/icons/files/file-download/16.svg';
import FileDownload24 from '@/assets/icons/files/file-download/24.svg';
import FileScript16 from '@/assets/icons/files/file-script/16.svg';
import FileScript24 from '@/assets/icons/files/file-script/24.svg';
import Pdf16 from '@/assets/icons/files/pdf/16.svg';
import Pdf24 from '@/assets/icons/files/pdf/24.svg';
import TextFile16 from '@/assets/icons/files/text-file/16.svg';
import TextFile24 from '@/assets/icons/files/text-file/24.svg';

import Ai16 from '@/assets/icons/general/ai/16.svg';
import Ai24 from '@/assets/icons/general/ai/24.svg';
import AiDetector16 from '@/assets/icons/general/ai-detector/16.svg';
import AiDetector24 from '@/assets/icons/general/ai-detector/24.svg';
import AiSearch16 from '@/assets/icons/general/ai-search/16.svg';
import AiSearch24 from '@/assets/icons/general/ai-search/24.svg';
import AlertCircle16 from '@/assets/icons/general/alert-circle/16.svg';
import AlertCircle24 from '@/assets/icons/general/alert-circle/24.svg';
import ArrowTurnForward16 from '@/assets/icons/general/arrow-turn-forward/16.svg';
import ArrowTurnForward24 from '@/assets/icons/general/arrow-turn-forward/24.svg';
import Brush16 from '@/assets/icons/general/brush/16.svg';
import Brush24 from '@/assets/icons/general/brush/24.svg';
import BubbleChat16 from '@/assets/icons/general/bubble-chat/16.svg';
import BubbleChat24 from '@/assets/icons/general/bubble-chat/24.svg';
import Bullet16 from '@/assets/icons/general/bullet/16.svg';
import Bullet24 from '@/assets/icons/general/bullet/24.svg';
import Check16 from '@/assets/icons/general/check/16.svg';
import Check24 from '@/assets/icons/general/check/24.svg';
import CheckDouble16 from '@/assets/icons/general/check-double/16.svg';
import CheckDouble24 from '@/assets/icons/general/check-double/24.svg';
import CheckList16 from '@/assets/icons/general/check-list/16.svg';
import CheckList24 from '@/assets/icons/general/check-list/24.svg';
import CheckmarkCircle16 from '@/assets/icons/general/checkmark-circle/16.svg';
import CheckmarkCircle24 from '@/assets/icons/general/checkmark-circle/24.svg';
import Chrome16 from '@/assets/icons/general/chrome/16.svg';
import Chrome24 from '@/assets/icons/general/chrome/24.svg';
import Citation16 from '@/assets/icons/general/citation/16.svg';
import Citation24 from '@/assets/icons/general/citation/24.svg';
import Copy16 from '@/assets/icons/general/copy/16.svg';
import Copy24 from '@/assets/icons/general/copy/24.svg';
import Delete16 from '@/assets/icons/general/delete/16.svg';
import Delete24 from '@/assets/icons/general/delete/24.svg';
import Download16 from '@/assets/icons/general/download/16.svg';
import Download24 from '@/assets/icons/general/download/24.svg';
import Edit16 from '@/assets/icons/general/edit/16.svg';
import Edit24 from '@/assets/icons/general/edit/24.svg';
import EllipseBullet16 from '@/assets/icons/general/ellipse-bullet/16.svg';
import Flashcards16 from '@/assets/icons/general/flashcards/16.svg';
import Flashcards24 from '@/assets/icons/general/flashcards/24.svg';
import HelpCircle16 from '@/assets/icons/general/help-circle/16.svg';
import HelpCircle24 from '@/assets/icons/general/help-circle/24.svg';
import Highlight16 from '@/assets/icons/general/highlight/16.svg';
import Highlight24 from '@/assets/icons/general/highlight/24.svg';
import History16 from '@/assets/icons/general/history/16.svg';
import History24 from '@/assets/icons/general/history/24.svg';
import Humanize16 from '@/assets/icons/general/humanize/16.svg';
import Humanize24 from '@/assets/icons/general/humanize/24.svg';
import Idea16 from '@/assets/icons/general/idea/16.svg';
import Idea24 from '@/assets/icons/general/idea/24.svg';
import Image16 from '@/assets/icons/general/image/16.svg';
import Image24 from '@/assets/icons/general/image/24.svg';
import InformationCircle16 from '@/assets/icons/general/information-circle/16.svg';
import InformationCircle24 from '@/assets/icons/general/information-circle/24.svg';
import Learn16 from '@/assets/icons/general/learn/16.svg';
import Learn24 from '@/assets/icons/general/learn/24.svg';
import Link16 from '@/assets/icons/general/link/16.svg';
import Link24 from '@/assets/icons/general/link/24.svg';
import LinkSquare16 from '@/assets/icons/general/link-square/16.svg';
import LinkSquare24 from '@/assets/icons/general/link-square/24.svg';
import Lock16 from '@/assets/icons/general/lock/16.svg';
import Lock24 from '@/assets/icons/general/lock/24.svg';
import NoteEdit16 from '@/assets/icons/general/note-edit/16.svg';
import NoteEdit24 from '@/assets/icons/general/note-edit/24.svg';
import Paperclip16 from '@/assets/icons/general/paperclip/16.svg';
import Paperclip24 from '@/assets/icons/general/paperclip/24.svg';
import Placeholder16 from '@/assets/icons/general/placeholder/16.svg';
import Placeholder24 from '@/assets/icons/general/placeholder/24.svg';
import Plagiarism16 from '@/assets/icons/general/plagiarism/16.svg';
import Plagiarism24 from '@/assets/icons/general/plagiarism/24.svg';
import PlusCircle16 from '@/assets/icons/general/plus-circle/16.svg';
import PlusCircle24 from '@/assets/icons/general/plus-circle/24.svg';
import PlusSign16 from '@/assets/icons/general/plus-sign/16.svg';
import PlusSign24 from '@/assets/icons/general/plus-sign/24.svg';
import Profile16 from '@/assets/icons/general/profile/16.svg';
import Profile24 from '@/assets/icons/general/profile/24.svg';
import QuillWrite16 from '@/assets/icons/general/quill-write/16.svg';
import QuillWrite24 from '@/assets/icons/general/quill-write/24.svg';
import Quiz16 from '@/assets/icons/general/quiz/16.svg';
import Quiz24 from '@/assets/icons/general/quiz/24.svg';
import References16 from '@/assets/icons/general/references/16.svg';
import References24 from '@/assets/icons/general/references/24.svg';
import Refresh16 from '@/assets/icons/general/refresh/16.svg';
import Refresh24 from '@/assets/icons/general/refresh/24.svg';
import ReprismChat16 from '@/assets/icons/general/reprism-chat/16.svg';
import ReprismChat24 from '@/assets/icons/general/reprism-chat/24.svg';
import ReprismIcon16 from '@/assets/icons/general/reprism-icon/16.svg';
import ReprismIcon24 from '@/assets/icons/general/reprism-icon/24.svg';
import Search16 from '@/assets/icons/general/search/16.svg';
import Search24 from '@/assets/icons/general/search/24.svg';
import SendArrowUp16 from '@/assets/icons/general/send-arrow-up/16.svg';
import SendArrowUp24 from '@/assets/icons/general/send-arrow-up/24.svg';
import Settings16 from '@/assets/icons/general/settings/16.svg';
import Settings24 from '@/assets/icons/general/settings/24.svg';
import Summary16 from '@/assets/icons/general/summary/16.svg';
import Summary24 from '@/assets/icons/general/summary/24.svg';
import TextGeneral16 from '@/assets/icons/general/text/16.svg';
import TextGeneral24 from '@/assets/icons/general/text/24.svg';
import ThumbsDown16 from '@/assets/icons/general/thumbs-down/16.svg';
import ThumbsDown24 from '@/assets/icons/general/thumbs-down/24.svg';
import ThumbsUp16 from '@/assets/icons/general/thumbs-up/16.svg';
import ThumbsUp24 from '@/assets/icons/general/thumbs-up/24.svg';
import Tokens16 from '@/assets/icons/general/tokens/16.svg';
import Tokens24 from '@/assets/icons/general/tokens/24.svg';
import Undo16 from '@/assets/icons/general/undo/16.svg';
import Undo24 from '@/assets/icons/general/undo/24.svg';
import Unlock16 from '@/assets/icons/general/unlock/16.svg';
import Unlock24 from '@/assets/icons/general/unlock/24.svg';
import Upload16 from '@/assets/icons/general/upload/16.svg';
import Upload24 from '@/assets/icons/general/upload/24.svg';
import Verified16 from '@/assets/icons/general/verified/16.svg';
import Verified24 from '@/assets/icons/general/verified/24.svg';
import View16 from '@/assets/icons/general/view/16.svg';
import View24 from '@/assets/icons/general/view/24.svg';
import ViewOff16 from '@/assets/icons/general/view-off/16.svg';
import ViewOff24 from '@/assets/icons/general/view-off/24.svg';
import WordCount16 from '@/assets/icons/general/word-count/16.svg';
import WordCount24 from '@/assets/icons/general/word-count/24.svg';
import Write16 from '@/assets/icons/general/write/16.svg';
import Write24 from '@/assets/icons/general/write/24.svg';

import ArrowDown16 from '@/assets/icons/navigation/arrow-down/16.svg';
import ArrowDown24 from '@/assets/icons/navigation/arrow-down/24.svg';
import ArrowLeft16 from '@/assets/icons/navigation/arrow-left/16.svg';
import ArrowLeft24 from '@/assets/icons/navigation/arrow-left/24.svg';
import ArrowRight16 from '@/assets/icons/navigation/arrow-right/16.svg';
import ArrowRight24 from '@/assets/icons/navigation/arrow-right/24.svg';
import ArrowUp16 from '@/assets/icons/navigation/arrow-up/16.svg';
import ArrowUp24 from '@/assets/icons/navigation/arrow-up/24.svg';
import ArrowUpLeft16 from '@/assets/icons/navigation/arrow-up-left/16.svg';
import ArrowUpLeft24 from '@/assets/icons/navigation/arrow-up-left/24.svg';
import ArrowUpRight16 from '@/assets/icons/navigation/arrow-up-right/16.svg';
import ArrowUpRight24 from '@/assets/icons/navigation/arrow-up-right/24.svg';
import ChevronDown16 from '@/assets/icons/navigation/chevron-down/16.svg';
import ChevronDown24 from '@/assets/icons/navigation/chevron-down/24.svg';
import ChevronLeft16 from '@/assets/icons/navigation/chevron-left/16.svg';
import ChevronLeft24 from '@/assets/icons/navigation/chevron-left/24.svg';
import ChevronRight16 from '@/assets/icons/navigation/chevron-right/16.svg';
import ChevronRight24 from '@/assets/icons/navigation/chevron-right/24.svg';
import ChevronUp16 from '@/assets/icons/navigation/chevron-up/16.svg';
import ChevronUp24 from '@/assets/icons/navigation/chevron-up/24.svg';
import ChevronsLeft16 from '@/assets/icons/navigation/chevrons-left/16.svg';
import ChevronsLeft24 from '@/assets/icons/navigation/chevrons-left/24.svg';
import ChevronsRight16 from '@/assets/icons/navigation/chevrons-right/16.svg';
import ChevronsRight24 from '@/assets/icons/navigation/chevrons-right/24.svg';
import Close16 from '@/assets/icons/navigation/close/16.svg';
import Close24 from '@/assets/icons/navigation/close/24.svg';
import LeftPanel16 from '@/assets/icons/navigation/left-panel/16.svg';
import LeftPanel24 from '@/assets/icons/navigation/left-panel/24.svg';
import LogOut16 from '@/assets/icons/navigation/log-out/16.svg';
import LogOut24 from '@/assets/icons/navigation/log-out/24.svg';
import Maximize16 from '@/assets/icons/navigation/maximize/16.svg';
import Maximize24 from '@/assets/icons/navigation/maximize/24.svg';
import Minimize16 from '@/assets/icons/navigation/minimize/16.svg';
import Minimize24 from '@/assets/icons/navigation/minimize/24.svg';
import MoreHorizontal16 from '@/assets/icons/navigation/more-horizontal/16.svg';
import MoreHorizontal24 from '@/assets/icons/navigation/more-horizontal/24.svg';
import MoreHorizontalOval16 from '@/assets/icons/navigation/more-horizontal_oval/16.svg';
import MoreHorizontalOval24 from '@/assets/icons/navigation/more-horizontal_oval/24.svg';

import Bold16 from '@/assets/icons/text-editor/bold/16.svg';
import Bold24 from '@/assets/icons/text-editor/bold/24.svg';
import BulletList16 from '@/assets/icons/text-editor/bullet-list/16.svg';
import BulletList24 from '@/assets/icons/text-editor/bullet-list/24.svg';
import Equation16 from '@/assets/icons/text-editor/equation/16.svg';
import Equation24 from '@/assets/icons/text-editor/equation/24.svg';
import H1_16 from '@/assets/icons/text-editor/h1/16.svg';
import H1_24 from '@/assets/icons/text-editor/h1/24.svg';
import H2_16 from '@/assets/icons/text-editor/h2/16.svg';
import H2_24 from '@/assets/icons/text-editor/h2/24.svg';
import H3_16 from '@/assets/icons/text-editor/h3/16.svg';
import H3_24 from '@/assets/icons/text-editor/h3/24.svg';
import H4_16 from '@/assets/icons/text-editor/h4/16.svg';
import H4_24 from '@/assets/icons/text-editor/h4/24.svg';
import H5_16 from '@/assets/icons/text-editor/h5/16.svg';
import H5_24 from '@/assets/icons/text-editor/h5/24.svg';
import Italic16 from '@/assets/icons/text-editor/italic/16.svg';
import Italic24 from '@/assets/icons/text-editor/italic/24.svg';
import NumberedList16 from '@/assets/icons/text-editor/numbered-list/16.svg';
import NumberedList24 from '@/assets/icons/text-editor/numbered-list/24.svg';
import Table16 from '@/assets/icons/text-editor/table/16.svg';
import Table24 from '@/assets/icons/text-editor/table/24.svg';
import Text16 from '@/assets/icons/text-editor/text/16.svg';
import Text24 from '@/assets/icons/text-editor/text/24.svg';
import Underline16 from '@/assets/icons/text-editor/underline/16.svg';
import Underline24 from '@/assets/icons/text-editor/underline/24.svg';

export type IconName =
  | 'files/file-download/16'
  | 'files/file-download/24'
  | 'files/file-script/16'
  | 'files/file-script/24'
  | 'files/pdf/16'
  | 'files/pdf/24'
  | 'files/text-file/16'
  | 'files/text-file/24'
  | 'general/ai/16'
  | 'general/ai/24'
  | 'general/ai-detector/16'
  | 'general/ai-detector/24'
  | 'general/ai-search/16'
  | 'general/ai-search/24'
  | 'general/alert-circle/16'
  | 'general/alert-circle/24'
  | 'general/arrow-turn-forward/16'
  | 'general/arrow-turn-forward/24'
  | 'general/brush/16'
  | 'general/brush/24'
  | 'general/bubble-chat/16'
  | 'general/bubble-chat/24'
  | 'general/bullet/16'
  | 'general/bullet/24'
  | 'general/check/16'
  | 'general/check/24'
  | 'general/check-double/16'
  | 'general/check-double/24'
  | 'general/check-list/16'
  | 'general/check-list/24'
  | 'general/checkmark-circle/16'
  | 'general/checkmark-circle/24'
  | 'general/chrome/16'
  | 'general/chrome/24'
  | 'general/citation/16'
  | 'general/citation/24'
  | 'general/copy/16'
  | 'general/copy/24'
  | 'general/delete/16'
  | 'general/delete/24'
  | 'general/download/16'
  | 'general/download/24'
  | 'general/edit/16'
  | 'general/edit/24'
  | 'general/ellipse-bullet/16'
  | 'general/flashcards/16'
  | 'general/flashcards/24'
  | 'general/help-circle/16'
  | 'general/help-circle/24'
  | 'general/highlight/16'
  | 'general/highlight/24'
  | 'general/history/16'
  | 'general/history/24'
  | 'general/humanize/16'
  | 'general/humanize/24'
  | 'general/idea/16'
  | 'general/idea/24'
  | 'general/image/16'
  | 'general/image/24'
  | 'general/information-circle/16'
  | 'general/information-circle/24'
  | 'general/learn/16'
  | 'general/learn/24'
  | 'general/link/16'
  | 'general/link/24'
  | 'general/link-square/16'
  | 'general/link-square/24'
  | 'general/lock/16'
  | 'general/lock/24'
  | 'general/note-edit/16'
  | 'general/note-edit/24'
  | 'general/paperclip/16'
  | 'general/paperclip/24'
  | 'general/placeholder/16'
  | 'general/placeholder/24'
  | 'general/plagiarism/16'
  | 'general/plagiarism/24'
  | 'general/plus-circle/16'
  | 'general/plus-circle/24'
  | 'general/plus-sign/16'
  | 'general/plus-sign/24'
  | 'general/profile/16'
  | 'general/profile/24'
  | 'general/quill-write/16'
  | 'general/quill-write/24'
  | 'general/quiz/16'
  | 'general/quiz/24'
  | 'general/references/16'
  | 'general/references/24'
  | 'general/refresh/16'
  | 'general/refresh/24'
  | 'general/reprism-chat/16'
  | 'general/reprism-chat/24'
  | 'general/reprism-icon/16'
  | 'general/reprism-icon/24'
  | 'general/search/16'
  | 'general/search/24'
  | 'general/send-arrow-up/16'
  | 'general/send-arrow-up/24'
  | 'general/settings/16'
  | 'general/settings/24'
  | 'general/summary/16'
  | 'general/summary/24'
  | 'general/text/16'
  | 'general/text/24'
  | 'general/thumbs-down/16'
  | 'general/thumbs-down/24'
  | 'general/thumbs-up/16'
  | 'general/thumbs-up/24'
  | 'general/tokens/16'
  | 'general/tokens/24'
  | 'general/undo/16'
  | 'general/undo/24'
  | 'general/unlock/16'
  | 'general/unlock/24'
  | 'general/upload/16'
  | 'general/upload/24'
  | 'general/verified/16'
  | 'general/verified/24'
  | 'general/view/16'
  | 'general/view/24'
  | 'general/view-off/16'
  | 'general/view-off/24'
  | 'general/word-count/16'
  | 'general/word-count/24'
  | 'general/write/16'
  | 'general/write/24'
  | 'navigation/arrow-down/16'
  | 'navigation/arrow-down/24'
  | 'navigation/arrow-left/16'
  | 'navigation/arrow-left/24'
  | 'navigation/arrow-right/16'
  | 'navigation/arrow-right/24'
  | 'navigation/arrow-up/16'
  | 'navigation/arrow-up/24'
  | 'navigation/arrow-up-left/16'
  | 'navigation/arrow-up-left/24'
  | 'navigation/arrow-up-right/16'
  | 'navigation/arrow-up-right/24'
  | 'navigation/chevron-down/16'
  | 'navigation/chevron-down/24'
  | 'navigation/chevron-left/16'
  | 'navigation/chevron-left/24'
  | 'navigation/chevron-right/16'
  | 'navigation/chevron-right/24'
  | 'navigation/chevron-up/16'
  | 'navigation/chevron-up/24'
  | 'navigation/chevrons-left/16'
  | 'navigation/chevrons-left/24'
  | 'navigation/chevrons-right/16'
  | 'navigation/chevrons-right/24'
  | 'navigation/close/16'
  | 'navigation/close/24'
  | 'navigation/left-panel/16'
  | 'navigation/left-panel/24'
  | 'navigation/log-out/16'
  | 'navigation/log-out/24'
  | 'navigation/maximize/16'
  | 'navigation/maximize/24'
  | 'navigation/minimize/16'
  | 'navigation/minimize/24'
  | 'navigation/more-horizontal/16'
  | 'navigation/more-horizontal/24'
  | 'navigation/more-horizontal_oval/16'
  | 'navigation/more-horizontal_oval/24'
  | 'text-editor/bold/16'
  | 'text-editor/bold/24'
  | 'text-editor/bullet-list/16'
  | 'text-editor/bullet-list/24'
  | 'text-editor/equation/16'
  | 'text-editor/equation/24'
  | 'text-editor/h1/16'
  | 'text-editor/h1/24'
  | 'text-editor/h2/16'
  | 'text-editor/h2/24'
  | 'text-editor/h3/16'
  | 'text-editor/h3/24'
  | 'text-editor/h4/16'
  | 'text-editor/h4/24'
  | 'text-editor/h5/16'
  | 'text-editor/h5/24'
  | 'text-editor/italic/16'
  | 'text-editor/italic/24'
  | 'text-editor/numbered-list/16'
  | 'text-editor/numbered-list/24'
  | 'text-editor/table/16'
  | 'text-editor/table/24'
  | 'text-editor/text/16'
  | 'text-editor/text/24'
  | 'text-editor/underline/16'
  | 'text-editor/underline/24';

export const iconMap: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  'files/file-download/16': FileDownload16,
  'files/file-download/24': FileDownload24,
  'files/file-script/16': FileScript16,
  'files/file-script/24': FileScript24,
  'files/pdf/16': Pdf16,
  'files/pdf/24': Pdf24,
  'files/text-file/16': TextFile16,
  'files/text-file/24': TextFile24,

  'general/ai/16': Ai16,
  'general/ai/24': Ai24,
  'general/ai-detector/16': AiDetector16,
  'general/ai-detector/24': AiDetector24,
  'general/ai-search/16': AiSearch16,
  'general/ai-search/24': AiSearch24,
  'general/alert-circle/16': AlertCircle16,
  'general/alert-circle/24': AlertCircle24,
  'general/arrow-turn-forward/16': ArrowTurnForward16,
  'general/arrow-turn-forward/24': ArrowTurnForward24,
  'general/brush/16': Brush16,
  'general/brush/24': Brush24,
  'general/bubble-chat/16': BubbleChat16,
  'general/bubble-chat/24': BubbleChat24,
  'general/bullet/16': Bullet16,
  'general/bullet/24': Bullet24,
  'general/check/16': Check16,
  'general/check/24': Check24,
  'general/check-double/16': CheckDouble16,
  'general/check-double/24': CheckDouble24,
  'general/check-list/16': CheckList16,
  'general/check-list/24': CheckList24,
  'general/checkmark-circle/16': CheckmarkCircle16,
  'general/checkmark-circle/24': CheckmarkCircle24,
  'general/chrome/16': Chrome16,
  'general/chrome/24': Chrome24,
  'general/citation/16': Citation16,
  'general/citation/24': Citation24,
  'general/copy/16': Copy16,
  'general/copy/24': Copy24,
  'general/delete/16': Delete16,
  'general/delete/24': Delete24,
  'general/download/16': Download16,
  'general/download/24': Download24,
  'general/edit/16': Edit16,
  'general/edit/24': Edit24,
  'general/ellipse-bullet/16': EllipseBullet16,
  'general/flashcards/16': Flashcards16,
  'general/flashcards/24': Flashcards24,
  'general/help-circle/16': HelpCircle16,
  'general/help-circle/24': HelpCircle24,
  'general/highlight/16': Highlight16,
  'general/highlight/24': Highlight24,
  'general/history/16': History16,
  'general/history/24': History24,
  'general/humanize/16': Humanize16,
  'general/humanize/24': Humanize24,
  'general/idea/16': Idea16,
  'general/idea/24': Idea24,
  'general/image/16': Image16,
  'general/image/24': Image24,
  'general/information-circle/16': InformationCircle16,
  'general/information-circle/24': InformationCircle24,
  'general/learn/16': Learn16,
  'general/learn/24': Learn24,
  'general/link/16': Link16,
  'general/link/24': Link24,
  'general/link-square/16': LinkSquare16,
  'general/link-square/24': LinkSquare24,
  'general/lock/16': Lock16,
  'general/lock/24': Lock24,
  'general/note-edit/16': NoteEdit16,
  'general/note-edit/24': NoteEdit24,
  'general/paperclip/16': Paperclip16,
  'general/paperclip/24': Paperclip24,
  'general/placeholder/16': Placeholder16,
  'general/placeholder/24': Placeholder24,
  'general/plagiarism/16': Plagiarism16,
  'general/plagiarism/24': Plagiarism24,
  'general/plus-circle/16': PlusCircle16,
  'general/plus-circle/24': PlusCircle24,
  'general/plus-sign/16': PlusSign16,
  'general/plus-sign/24': PlusSign24,
  'general/profile/16': Profile16,
  'general/profile/24': Profile24,
  'general/quill-write/16': QuillWrite16,
  'general/quill-write/24': QuillWrite24,
  'general/quiz/16': Quiz16,
  'general/quiz/24': Quiz24,
  'general/references/16': References16,
  'general/references/24': References24,
  'general/refresh/16': Refresh16,
  'general/refresh/24': Refresh24,
  'general/reprism-chat/16': ReprismChat16,
  'general/reprism-chat/24': ReprismChat24,
  'general/reprism-icon/16': ReprismIcon16,
  'general/reprism-icon/24': ReprismIcon24,
  'general/search/16': Search16,
  'general/search/24': Search24,
  'general/send-arrow-up/16': SendArrowUp16,
  'general/send-arrow-up/24': SendArrowUp24,
  'general/settings/16': Settings16,
  'general/settings/24': Settings24,
  'general/summary/16': Summary16,
  'general/summary/24': Summary24,
  'general/text/16': TextGeneral16,
  'general/text/24': TextGeneral24,
  'general/thumbs-down/16': ThumbsDown16,
  'general/thumbs-down/24': ThumbsDown24,
  'general/thumbs-up/16': ThumbsUp16,
  'general/thumbs-up/24': ThumbsUp24,
  'general/tokens/16': Tokens16,
  'general/tokens/24': Tokens24,
  'general/undo/16': Undo16,
  'general/undo/24': Undo24,
  'general/unlock/16': Unlock16,
  'general/unlock/24': Unlock24,
  'general/upload/16': Upload16,
  'general/upload/24': Upload24,
  'general/verified/16': Verified16,
  'general/verified/24': Verified24,
  'general/view/16': View16,
  'general/view/24': View24,
  'general/view-off/16': ViewOff16,
  'general/view-off/24': ViewOff24,
  'general/word-count/16': WordCount16,
  'general/word-count/24': WordCount24,
  'general/write/16': Write16,
  'general/write/24': Write24,

  'navigation/arrow-down/16': ArrowDown16,
  'navigation/arrow-down/24': ArrowDown24,
  'navigation/arrow-left/16': ArrowLeft16,
  'navigation/arrow-left/24': ArrowLeft24,
  'navigation/arrow-right/16': ArrowRight16,
  'navigation/arrow-right/24': ArrowRight24,
  'navigation/arrow-up/16': ArrowUp16,
  'navigation/arrow-up/24': ArrowUp24,
  'navigation/arrow-up-left/16': ArrowUpLeft16,
  'navigation/arrow-up-left/24': ArrowUpLeft24,
  'navigation/arrow-up-right/16': ArrowUpRight16,
  'navigation/arrow-up-right/24': ArrowUpRight24,
  'navigation/chevron-down/16': ChevronDown16,
  'navigation/chevron-down/24': ChevronDown24,
  'navigation/chevron-left/16': ChevronLeft16,
  'navigation/chevron-left/24': ChevronLeft24,
  'navigation/chevron-right/16': ChevronRight16,
  'navigation/chevron-right/24': ChevronRight24,
  'navigation/chevron-up/16': ChevronUp16,
  'navigation/chevron-up/24': ChevronUp24,
  'navigation/chevrons-left/16': ChevronsLeft16,
  'navigation/chevrons-left/24': ChevronsLeft24,
  'navigation/chevrons-right/16': ChevronsRight16,
  'navigation/chevrons-right/24': ChevronsRight24,
  'navigation/close/16': Close16,
  'navigation/close/24': Close24,
  'navigation/left-panel/16': LeftPanel16,
  'navigation/left-panel/24': LeftPanel24,
  'navigation/log-out/16': LogOut16,
  'navigation/log-out/24': LogOut24,
  'navigation/maximize/16': Maximize16,
  'navigation/maximize/24': Maximize24,
  'navigation/minimize/16': Minimize16,
  'navigation/minimize/24': Minimize24,
  'navigation/more-horizontal/16': MoreHorizontal16,
  'navigation/more-horizontal/24': MoreHorizontal24,
  'navigation/more-horizontal_oval/16': MoreHorizontalOval16,
  'navigation/more-horizontal_oval/24': MoreHorizontalOval24,

  'text-editor/bold/16': Bold16,
  'text-editor/bold/24': Bold24,
  'text-editor/bullet-list/16': BulletList16,
  'text-editor/bullet-list/24': BulletList24,
  'text-editor/equation/16': Equation16,
  'text-editor/equation/24': Equation24,
  'text-editor/h1/16': H1_16,
  'text-editor/h1/24': H1_24,
  'text-editor/h2/16': H2_16,
  'text-editor/h2/24': H2_24,
  'text-editor/h3/16': H3_16,
  'text-editor/h3/24': H3_24,
  'text-editor/h4/16': H4_16,
  'text-editor/h4/24': H4_24,
  'text-editor/h5/16': H5_16,
  'text-editor/h5/24': H5_24,
  'text-editor/italic/16': Italic16,
  'text-editor/italic/24': Italic24,
  'text-editor/numbered-list/16': NumberedList16,
  'text-editor/numbered-list/24': NumberedList24,
  'text-editor/table/16': Table16,
  'text-editor/table/24': Table24,
  'text-editor/text/16': Text16,
  'text-editor/text/24': Text24,
  'text-editor/underline/16': Underline16,
  'text-editor/underline/24': Underline24,
};
